import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'tf-core-fb-basic-input-checklist-rate-type',
  templateUrl: './fb-basic-input-checklist-rate-type.component.html',
  styleUrls: ['./fb-basic-input-checklist-rate-type.component.css']
})
export class FbCoreBasicInputChecklistRateTypeComponent implements OnInit {
    @Input()
    data: any;

    constructor() { }

    ngOnInit(): void {
        if (this.data === undefined) {
            this.data = {
                type: 'rate',
                number: 5
            };
        }
    }
}
